import { parseAttributes } from "../../lib/utils"
import useLocationData from "../../hooks/use-location-data"
import {
	StateFieldConfig,
	type Attribute,
	type FieldProps,
} from "../../types/form-types"
import { SelectField } from "./select"
import { useEffect, useMemo } from "react"
import { useLocationStore } from "../../stores/use-location-store"
import { useFormStore } from "@/stores/use-form-store"

export const StateField = ({ field, form, commonAttributes }: FieldProps) => {
	const { submissionValues, applicationSubmission } = useFormStore()
	const { countryFieldId } = getStateFieldAttributes(field.attributes)
	const selectedCountry = countryFieldId
		? form.watch(countryFieldId!) || applicationSubmission[countryFieldId]
		: "India"
	const { useGetStatesByCountry } = useLocationData()
	const { data: states, isSuccess } = useGetStatesByCountry(selectedCountry)
	const {
		pendingStateFieldId,
		pendingState,
		setPendingState,
		setPendingStateFieldId,
	} = useLocationStore()

	const options = useMemo(() => {
		if (!states) return []

		return states.map(state => ({
			label: state.name,
			value: state.name,
		}))
	}, [states])

	useEffect(() => {
		if (isSuccess && options.length > 0) {
			if (pendingState && pendingStateFieldId) {
				form.setValue(pendingStateFieldId, pendingState)
				setPendingState(null)
				setPendingStateFieldId(null)
			}

			if (submissionValues && submissionValues[field.field_id]) {
				const value = submissionValues[field.field_id]
				if (value != "") form.setValue(field.field_id, value)
			}
		}
	}, [isSuccess, options, pendingState, pendingStateFieldId])

	return (
		<SelectField
			field={field}
			form={form}
			commonAttributes={commonAttributes}
			optionsPreSet={options}
			isDisabled={!selectedCountry}
		/>
	)
}

function getStateFieldAttributes(attributes: Attribute[]) {
	const props: {
		countryFieldId?: string
	} = {}

	const parsedAttributes = parseAttributes(attributes)

	Object.entries(parsedAttributes).forEach(([key, value]) => {
		switch (key) {
			case StateFieldConfig.CountryFieldId:
				props.countryFieldId = value as string
				break
		}
	})

	return props
}
